import React from 'react';
import { Field } from 'formik';

import { groupingByOptions } from './requests-report-options';

import { useStipReport } from '../../hooks/use-stip-report';
import { useFetchServices } from '../../hooks/fetch/use-fetch-services';
import { useFetchServiceStatus } from '../../hooks/fetch/use-fetch-service-status';
import { useFetchEmployeesByDepartment } from '../../hooks/fetch/use-fetch-employees-by-department';

import Loading from '../../../../layouts/Loading';
import CustomMaskField from '../../components/temp/CustomMaskField';

import { GridItem } from '../../components/GridItem';
import { ReportSelect } from '../../components/ReportSelect';
import { ReportTextField } from '../../components/ReportTextField';
import { ReportDatePicker } from '../../components/ReportDatePicker';
import { ReportMultiSelect } from '../../components/ReportMultiSelect';
import { ReportSectionTitle } from '../../components/ReportSectionTitle';
import { ReportTogglerGroup } from '../../components/ReportTogglerGroup';
import { ReportDocumentField } from '../../components/ReportDocumentField';
import { ReportMultiAutocomplete } from '../../components/ReportMultiAutocomplete';

const RequestsReport = () => {
  const { handleSelectChange, handleToggleChange } = useStipReport();

  const { loading: loadingServices, services } = useFetchServices();
  const { loading: loadingSituations, situations } = useFetchServiceStatus();
  const { loading: loadingDepartments, departments, employees } = useFetchEmployeesByDepartment();

  const loading = loadingServices || loadingSituations;
  const noEmployees = employees.length === 0;
  const employeesFieldLabel = noEmployees ? 'Todos os analistas' : 'Selecione o analista';

  const getSectorFieldLabel = option => `${option.sgOrgaoSetor} - ${option.nmOrgaoSetor}`;

  if (loading) {
    return <Loading />;
  }

  return (
    <GridItem container spacing={3}>
      <GridItem>
        <ReportSectionTitle>Selecionar tipo de solicitação:</ReportSectionTitle>
      </GridItem>
      <GridItem sm={6}>
        <ReportMultiAutocomplete
          options={services}
          onSelect={handleSelectChange}
          label="Todas as solicitações"
          name="servicos"
          valueProperty="cdServico"
          labelProperty="nmServico"
          limitTags={1}
        />
      </GridItem>

      <GridItem>
        <ReportSectionTitle divider>Opções de filtro:</ReportSectionTitle>
      </GridItem>
      <GridItem>
        <ReportSectionTitle>Filtrar por data de cadastro:</ReportSectionTitle>
      </GridItem>
      <GridItem sm={6}>
        <ReportDatePicker name="dtCadastro.dtInicio" label="Início" />
      </GridItem>
      <GridItem sm={6}>
        <ReportDatePicker name="dtCadastro.dtFim" label="Fim" />
      </GridItem>
      <GridItem>
        <ReportSectionTitle>Filtrar por data de finalização:</ReportSectionTitle>
      </GridItem>
      <GridItem sm={6}>
        <ReportDatePicker name="dtFinalizacao.dtInicio" label="Início" />
      </GridItem>
      <GridItem sm={6}>
        <ReportDatePicker name="dtFinalizacao.dtFim" label="Fim" />
      </GridItem>

      <GridItem>
        <ReportSectionTitle divider>Buscar por requerente</ReportSectionTitle>
      </GridItem>
      <GridItem sm={6}>
        <ReportTextField name="nmOperador" label="Nome ou razão social" />
      </GridItem>
      <GridItem sm={3}>
        <ReportDocumentField name="nuDocumentoOperador" label="CPF ou CNPJ do requerente" />
      </GridItem>

      <GridItem>
        <ReportSectionTitle divider />
      </GridItem>
      <GridItem sm={6}>
        <ReportSectionTitle gutterBottom>Selecione o(s) setores(s):</ReportSectionTitle>
        <ReportMultiAutocomplete
          options={departments}
          disabled={loadingDepartments}
          onSelect={handleSelectChange}
          label="Todos os setores"
          name="setores"
          valueProperty="cdOrgaoSetor"
          labelProperty="nmOrgaoSetor"
          getOptionLabel={getSectorFieldLabel}
        />
      </GridItem>
      <GridItem sm={6}>
        <ReportSectionTitle gutterBottom>Analista:</ReportSectionTitle>
        <ReportMultiSelect
          options={employees}
          loading={loadingDepartments}
          disabled={loadingDepartments || noEmployees}
          name="usuarios"
          label={employeesFieldLabel}
          labelProperty="nmUsuario"
          valueProperty="cdUsuario"
          onSelect={handleSelectChange}
          selectAll
        />
      </GridItem>

      <GridItem>
        <ReportSectionTitle divider>Solicitação:</ReportSectionTitle>
      </GridItem>
      <GridItem sm={3}>
        <Field
          component={CustomMaskField}
          name="nuSolicitacao"
          mask="999999/9999"
          label="Número da solicitação"
          variant="outlined"
        />
      </GridItem>

      <GridItem>
        <ReportSectionTitle divider>Situação:</ReportSectionTitle>
      </GridItem>
      <GridItem sm={6}>
        <ReportMultiSelect
          options={situations}
          name="situacoesCadastro"
          label="Selecione a(s) situação(ões)"
          onSelect={handleSelectChange}
          labelProperty="deSituacao"
          valueProperty="cdSituacao"
          selectAll
        />
      </GridItem>

      <GridItem>
        <ReportSectionTitle divider>Opções de agrupamento:</ReportSectionTitle>
      </GridItem>
      <GridItem sm={6}>
        <ReportSelect
          options={groupingByOptions}
          name="agrupamento"
          onSelect={handleSelectChange}
        />
      </GridItem>

      <GridItem>
        <ReportSectionTitle divider>Outras opções:</ReportSectionTitle>
      </GridItem>
      <GridItem sm={6}>
        <ReportTogglerGroup
          options={[{ label: 'Exibir resumo', name: 'boExibirResumo' }]}
          onToggle={handleToggleChange}
        />
      </GridItem>
    </GridItem>
  );
};

export default RequestsReport;
